import React from 'react'
import Icon from '@cloudscape-design/components-themed/icon'

// https://cloudscape.design/components/icon
export function RadIcon ({ ...rest }) {
  return (
    <Icon {...rest} />
  )
}
